import * as types from './type'

const initialState = {
  data: [],
  dataList: [],
  loading: false,
  createSuccess: false,
  editLoad: false,
}

export const smsconfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SMSCONFIG:
      return {
        ...state,
        ...{ loading: true, createSuccess: false },
      }

    case types.GET_SMSCONFIG_SUCCESS:
      return {
        ...state,
        ...{
          dataList: action.payload,
          loading: false
        }
      }

    case types.GET_SMSCONFIG_FAIL:
      {
        return {
          ...state,
          ...{ dataList: [], loading: false }
        }
      }

    case types.CREATE_SMSCONFIG:
      return {
        ...state,
        ...{ loading: true }
      }

    case types.CREATE_SMSCONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        createSuccess: true,
      }

    case types.CREATE_SMSCONFIG_FAIL:
      return {
        ...state,
        loading: false,
        data: action.payload.response.data,
      }

    
    case types.RESET_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        data: []
      }
      //edit
      case types.EDIT_SMSCONFIG: 
      return {
          ...state,
          editLoad: true,

      }
      case types.EDIT_SMSCONFIG_SUCCESS:
      return {
          ...state,
          editLoad: false,
      }
    default:
      return state
  }
}